import { Column } from '../objects/column';
import { Preferences } from '../../profile/objects/preferences';
import { ListPreferenceResult, setListPreference } from '../../utils/list/utils/setListPreference';
import { DEFAULT_COLUMN } from '../constants/manualFlighArrayConstants';

export const MANUAL_FLIGHT_MODULE = 'MANUAL_FLIGHT';

export const DEFAULT_MANUAL_FLIGHT_COLUMNS: Column[] = DEFAULT_COLUMN;

export const setManualFlightPreference = (prefs: Preferences[], cols: Column[]): ListPreferenceResult =>
    setListPreference(prefs, cols, { module: MANUAL_FLIGHT_MODULE, default_columns: DEFAULT_MANUAL_FLIGHT_COLUMNS, default_order_by: '-created_date', default_order: 'asc' });
